import { render } from "./AdultsLanding.vue?vue&type=template&id=3d0f47bf&scoped=true"
import script from "./AdultsLanding.vue?vue&type=script&lang=js"
export * from "./AdultsLanding.vue?vue&type=script&lang=js"

import "./AdultsLanding.vue?vue&type=style&index=0&id=3d0f47bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0f47bf"]])

export default __exports__